export const DefaultPlayNarrativeLabelIds = {
  Part: "narrativeLabelPart",
  Act: "narrativeLabelAct",
  Scene: "narrativeLabelScene",
  Sequence: "narrativeLabelSequence",
  Prologue: "narrativeLabelPrologue",
  Epilogue: "narrativeLabelEpilogue"
};

const makeNarrativeLabel = (id, label) => {
  return { id, label };
};

export default [
  makeNarrativeLabel(DefaultPlayNarrativeLabelIds.Book, "Book"),
  makeNarrativeLabel(DefaultPlayNarrativeLabelIds.Part, "Part"),
  makeNarrativeLabel(DefaultPlayNarrativeLabelIds.Chapter, "Chapter"),
  makeNarrativeLabel(DefaultPlayNarrativeLabelIds.Scene, "Scene"),
  makeNarrativeLabel(DefaultPlayNarrativeLabelIds.Prologue, "Prologue"),
  makeNarrativeLabel(DefaultPlayNarrativeLabelIds.Epilogue, "Epilogue")
];
